import { useRef, useState } from 'react';
import { gcoinRequest, gcoinRequestId } from '../gcoinApi';

export default function useGCoinMutation(token, accountId, scope = 'money') {
    const key = `gcoin-pending:${accountId}:${scope}`;
    const [pending, setPending] = useState(() => {
        try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
    });
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const inFlight = useRef(false);
    const run = async (path, payload, title) => {
        if (inFlight.current) return null;
        inFlight.current = true; setBusy(true); setError('');
        let saved = pending;
        try {
            saved = saved || { path, payload: { ...payload, request_id: gcoinRequestId() }, title };
            // До отправки сохраняем точное тело для повтора после перезагрузки.
            sessionStorage.setItem(key, JSON.stringify(saved));
        } catch {
            setError('Не удалось сохранить операцию в браузере. Разреши хранилище и повтори.');
            inFlight.current = false; setBusy(false); return null;
        }
        setPending(saved);
        try {
            const result = await gcoinRequest(token, saved.path, { method: 'POST', data: saved.payload });
            sessionStorage.removeItem(key); setPending(null);
            return result;
        } catch (err) {
            if (!err.uncertain && err.status) {
                sessionStorage.removeItem(key); setPending(null);
            }
            setError(err.message || 'Не удалось завершить операцию. Повтори запрос.');
            return null;
        } finally { inFlight.current = false; setBusy(false); }
    };
    return { run, pending, busy, error, clearError: () => setError('') };
}